<script setup>
import DiscoverExpertCard from "./DiscoverExpertCard.vue";

defineProps({
    experts: {
        type: Array,
        default: () => [],
    },
});
</script>

<template>
    <section v-if="experts.length">
        <header class="mb-6">
            <h2 class="font-brand text-[24px] font-bold text-[#102a3d]">
                Discover Experts
            </h2>
        </header>

        <div
            class="grid grid-cols-1 gap-x-10 gap-y-6 md:grid-cols-2 xl:grid-cols-3"
        >
            <DiscoverExpertCard
                v-for="expert in experts"
                :key="expert.uuid"
                :expert="expert"
            />
        </div>
    </section>
</template>
